module.exports = __webpack_public_path__ + "img/kjBanner7.4b61d44d.jpg";